import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'plus'
})
export class PlusPipe implements PipeTransform {

  transform(value: number, args?: number): any {
    if(value){
      let nbr = Number(value)+Number(args);
      return   nbr.toFixed(2);
    }
    return null;
  }

}



// WEBPACK FOOTER //
// ./src/pipes/plus/plus.pipe.ts